import React, {Component} from 'react';
import { Transformer, Image } from 'react-konva';
import rotateImage from "../../../../../assets/images/images.jpg";

class TransformerComponent extends Component {
  image = null;

  componentDidMount() {
    this.checkNode();
    this.loadImage(rotateImage);
  }

  componentDidUpdate() {
    this.checkNode();
  }

  loadImage(url) {
    this.image = new window.Image();
    this.image.src = url;
    this.image.addEventListener('load', this.handleLoad);
  }

  checkNode() {
    // here we need to manually attach or detach Transformer node
    const stage = this.transformer.getStage();
    const {selectedShapeName} = this.props;
    const selectedNode = stage.findOne('.' + selectedShapeName);
    // do nothing if selected node is already attached
    if (selectedNode === this.transformer.node()) {
      return;
    }

    if (selectedNode) {
      if (selectedNode.className === "Arrow") {
        this.transformer.enabledAnchors(['middle-right', 'middle-left'])
      }
      if (selectedNode.className !== "Arrow") {
        this.transformer.enabledAnchors(['top-left', 'top-right', 'bottom-left', 'bottom-right'])
      }
      // attach to another node
      this.transformer.nodes([selectedNode]);
    } else {
      // remove transformer
      this.transformer.detach();
    }
    this.transformer.getLayer().batchDraw();
  }

  transform = () => {
    this.rotateImage.x(this.transformer ? this.transformer.getWidth() / 2  - 15: 0);
    this.rotateImage.y(-60);
  }

  angle(cx, cy, ex, ey) {
    var dy = ey - cy;
    var dx = ex - cx;
    var theta = Math.atan2(dy, dx); // range (-PI, PI]
    theta *= 180 / Math.PI; // rads to degs, range (-180, 180]
    //if (theta < 0) theta = 360 + theta; // range [0, 360)
    return theta;
  }

  rotateElement = (e) => {
    const stage = this.transformer.getStage();
    const {selectedShapeName} = this.props;
    const selectedNode = stage.findOne('.' + selectedShapeName);
    selectedNode.rotation(this.angle((selectedNode.attrs.x + 200), (selectedNode.attrs.y + 200), e.evt.clientX,  e.evt.clientY, ));
    this.rotateImage.x(this.transformer ? this.transformer.getWidth() / 2  - 15: 0);
    this.rotateImage.y(-60);
  }

  render() {
    return (
      <Transformer
        ref={node => {
          this.transformer = node;
          this.props.setRef(node);
        }}
        onTransform={this.transform}
      >
        <Image
          x={this.transformer ? this.transformer.getWidth() / 2  - 15: 0}
          y={-60}
          width={30}
          height={30}
          name='rotateImage'
          subType='arrowRight'
          offset={3}
          fill='black'
          points={[10,80, 200,80]}
          pointerLength={20}
          pointerWidth={20}
          stroke='white'
          strokeWidth={2}
          dash={[0,0]}
          scaleX={1}
          scaleY={1}
          image={this.image}
          pointerAtBeginning={false}
          onDragMove={this.rotateElement}
          draggable={true}
          ref={node => {
            this.rotateImage = node;
          }}
        />
      </Transformer>
    );
  }
}

//export default (<Test />, document.getElementById('root'));
export default (TransformerComponent);



// WEBPACK FOOTER //
// ./src/components/InfluencerMap/CustomerInfluencerMap/CustomerInfluencerMapCanvasRounds/TransformerComponent/TransformerComponent.jsx